import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { apiErrorMessage } from '../../utils/api-error-message';
import PolicyConsentModal from '../policy/policy-consent-modal';
import { setBrandCreatorTaxCode } from '../../api/payment/brand-deal.api';
import { BRAND_TAX_POLICY_KEY, normalizeTaxCode, validateTaxCode } from '../../utils/brand-tax';

/**
 * Điều khoản thuế khi nhận tiền hợp tác + ô mã số thuế (không bắt buộc) ngay dưới nội dung. Bấm "Đồng ý": ghi nhận đồng ý ở
 * user-service, có điền thì lưu mã số thuế ở payment, rồi báo onDone để nơi gọi tự chạy lại thao tác vừa bấm.
 */
const BrandTaxConsentDialog: React.FC<{ open: boolean; onClose: () => void; onDone: () => void }> = ({ open, onClose, onDone }) => {
  const [taxCode, setTaxCode] = useState('');
  const error = validateTaxCode(taxCode);

  // Đóng hộp thì xoá mã đã gõ, mở lại là hộp trắng.
  useEffect(() => {
    if (!open) setTaxCode('');
  }, [open]);

  return (
    <PolicyConsentModal
      open={open}
      policyKey={BRAND_TAX_POLICY_KEY}
      submitLabel="Đồng ý"
      submitDisabled={!!error}
      onClose={onClose}
      onAccepted={async () => {
        const value = normalizeTaxCode(taxCode);
        if (value) {
          try {
            await setBrandCreatorTaxCode(value);
          } catch (e) {
            // Đồng ý đã ghi nhận rồi; chỉ mã số thuế chưa lưu được. Giữ hộp mở để thử lại.
            toast.error(apiErrorMessage(e, 'Đã ghi nhận đồng ý nhưng chưa lưu được mã số thuế. Bạn thử lại nhé.'));
            return;
          }
        }
        onDone();
      }}
    >
      <div className="ui-divider mt-2 border-t pt-3">
        <label htmlFor="brand-tax-code" className="block text-sm font-semibold ui-text">
          Mã số thuế cá nhân (không bắt buộc)
        </label>
        <input
          id="brand-tax-code"
          value={taxCode}
          inputMode="numeric"
          maxLength={20}
          onChange={(e) => setTaxCode(e.target.value)}
          className="ui-input mt-1 w-full rounded-md border px-3 py-2 text-sm"
        />
        <p className="mt-1 text-[12px] ui-muted">Điền mã số thuế giúp việc kê khai sau này thuận tiện hơn.</p>
        {error && <p className="mt-1 text-[12px] text-red-600">{error}</p>}
      </div>
    </PolicyConsentModal>
  );
};

export default BrandTaxConsentDialog;
